import React from 'react';
import Typography from '@material-ui/core/Typography';

const Options = props => {
  return (
    <div className='item-container'>
      <div id='item'>
        <div variant='title' gutterBottom>
          <span id='option-title'>
            Choose The {props.name.replace('_', ' ')}
          </span>
        </div>
        <br />
      </div>
    </div>
  );
};
export default Options;



// WEBPACK FOOTER //
// ./src/components/Options.js